var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from "react";
import Tooltip from "../tooltip";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useFetcher } from 'rest-hooks';
import DeleteIcon from '@material-ui/icons/Delete';
const useStyles = makeStyles(theme => ({
    iconButton: {
        '&:hover': {
            color: theme.palette.primary.main
        }
    }
}));
export const AdminDeleteButton = ({ title, confirmText, resourceDefinition, id }) => {
    const [open, setOpen] = React.useState(false);
    const style = useStyles();
    const handleClickOpen = useCallback(() => {
        setOpen(true);
    }, [setOpen]);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, [setOpen]);
    const deletePage = useFetcher(resourceDefinition.delete());
    const perform = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield deletePage({ id }, undefined);
        handleClose();
    }), [id, handleClose, deletePage]);
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: t('Supprimer') },
            React.createElement(IconButton, { className: style.iconButton, onClick: handleClickOpen },
                React.createElement(DeleteIcon, null))),
        React.createElement(Dialog, { open: open, onClose: handleClose },
            React.createElement(DialogTitle, null, title),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, null, confirmText)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: handleClose, color: "primary" }, t('Non')),
                React.createElement(Button, { onClick: perform, color: "primary", autoFocus: true }, t('Oui'))))));
};
//# sourceMappingURL=index.js.map